import { Box, Stack } from "@mui/material";
import { LiaPhoneSolid } from "react-icons/lia";
import { HiOutlineMail } from "react-icons/hi";
import { MdOutlineAccessTime } from "react-icons/md";
import LocationMap from "../../../../shared/components/Map";

import React from "react";
import { useTranslation } from "react-i18next";
import { ContactUsForm } from "./ContactUsForm";

const ContactUsSection: React.FC = () => {
  const { t } = useTranslation();

  const contactInfo = [
    {
      icon: <LiaPhoneSolid size={"1.5rem"} />,
      label: t("contact_phone"),
      value: "+971567729666",
    },
    {
      icon: <HiOutlineMail size={"1.5rem"} />,
      label: t("contact_email"),
      value: "info@wecarebusiness.com",
    },
    {
      icon: <MdOutlineAccessTime size={"1.5rem"} />,
      label: t("contact_working_hours"),
      value: t("contact_working_hours_value"),
    },
  ];

  return (
    <section id="ContactUsSection">
      <Stack
        direction={{ xs: "column", lg: "row" }}
        display={"flex"}
        marginBottom={"2rem"}
      >
        <ContactUsForm Contacts={contactInfo} />
        <Box
          flex={1}
          marginX={{ xs: "0", lg: "1rem" }}
          marginY={{ xs: "1rem" }}
        >
          <LocationMap />
        </Box>
      </Stack>
    </section>
  );
};

export default ContactUsSection;
